<template>
  <div v-if="dialogOpen">
        <section-container :section="section"
                           :dialogOpen="dialogOpen"
                           :extended="true"
                           :fullscreen="fullscreen"
                           :midSize="midSize"
                           :dialogWidth="dialogWidth"
                           :showMissing="showMissing"
                           @setSize="setSize"
                           @updated="dataUpdated"
                           @closeDialog="closeDialog"
                           @saved="saved">
        </section-container>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";
import SectionContainer from '@/framework/base/components/SectionContainer.vue';
import { Modules  } from '@/generated/classes/AppSchema';
import Route from '@/extend/classes/Route';
import Section from '@/framework/base/classes/Section';
import { goToModule } from '@/framework/base/helpers/NavHelper';
import { ModuleAbonnementOpenFiche } from '@/generated/modules/ModuleAbonnement.vue';
import { ModuleAdminOpenFiche } from '@/framework/admin/components/ModuleAdmin.vue';
import { ModuleCartOpenFiche } from '@/generated/modules/ModuleCart.vue';
import { ModuleComptaOpenFiche } from '@/generated/modules/ModuleCompta.vue';
import { ModuleDocumentOpenFiche } from '@/generated/modules/ModuleDocument.vue';
import { ModuleMarketingOpenFiche } from '@/generated/modules/ModuleMarketing.vue';
import { ModuleNotificationOpenFiche } from '@/custom/modules/ModuleNotification.vue';
import { ModulePreferenceOpenFiche } from '@/generated/modules/ModulePreference.vue';
import { ModuleProfilOpenFiche } from '@/generated/modules/ModuleProfil.vue';
import { ModuleProjetOpenFiche } from '@/generated/modules/ModuleProjet.vue';
import { ModuleSalarieOpenFiche } from '@/generated/modules/ModuleSalarie.vue';
import { ModuleEtablissementOpenFiche } from '@/generated/modules/ModuleEtablissement.vue';
import { ModuleSupportOpenFiche } from '@/generated/modules/ModuleSupport.vue';

export default defineComponent({
  components: {
    SectionContainer,
  },

    props: {
      route: {
        type: Object as PropType<Route>,
        required: true
      },
    },

    data() {
      return {
        lastRoute: new Route(),
        section: new Section(),
        fullscreen: false,
        midSize: false,
        dialogWidth: undefined as number | string | undefined,
        showMissing: true,
        dialogOpen: false
      }
    },

    methods: {
      closeDialog () {
        this.lastRoute = this.route;
        this.$emit('closeDialog', this.route);
      },

      setSize (fullscreen: boolean, midSize: boolean, width?: number | string) {
        this.fullscreen = fullscreen;
        this.midSize = midSize;
        this.dialogWidth = width;
      },

      fillData (route: Route) {
        switch (route.module) { 
          case Modules.ABONNEMENT: {
            const routeElements = ModuleAbonnementOpenFiche(route);
            this.section = routeElements.section;
            break;
          }
          case Modules.ADMIN: {
            const routeElements = ModuleAdminOpenFiche(route);
            this.section = routeElements.section;
            break;
          }
          case Modules.CART: {
            const routeElements = ModuleCartOpenFiche(route);
            this.section = routeElements.section;
            break;
          }
          case Modules.COMPTA: {
            const routeElements = ModuleComptaOpenFiche(route);
            this.section = routeElements.section;
            break;
          }
          case Modules.DOCUMENT: {
            const routeElements = ModuleDocumentOpenFiche(route);
            this.section = routeElements.section;
            break;
          }
          case Modules.MARKETING: {
            const routeElements = ModuleMarketingOpenFiche(route);
            this.section = routeElements.section;
            break;
          }
          case Modules.NOTIFICATION: {
            const routeElements = ModuleNotificationOpenFiche(route);
            this.section = routeElements.section;
            break;
          }
          case Modules.PREFERENCE: {
            const routeElements = ModulePreferenceOpenFiche(route);
            this.section = routeElements.section;
            break;
          }
          case Modules.PROFIL: {
            const routeElements = ModuleProfilOpenFiche(route);
            this.section = routeElements.section;
            break;
          }
          case Modules.PROJET: {
            const routeElements = ModuleProjetOpenFiche(route);
            this.section = routeElements.section;
            break;
          }
          case Modules.SALARIE: {
            const routeElements = ModuleSalarieOpenFiche(route);
            this.section = routeElements.section;
            break;
          }
          case Modules.ETABLISSEMENT: {
            const routeElements = ModuleEtablissementOpenFiche(route);
            this.section = routeElements.section;
            break;
          }
          case Modules.SUPPORT: {
            const routeElements = ModuleSupportOpenFiche(route);
            this.section = routeElements.section;
            break;
          }
        }
      },

      // eslint-disable-next-line
      dataUpdated (data: any): void {
        // To override
      }
    }
  })
</script>
